<template>
  <!-- Use inline style to override v-app-bar's inline `position: fixed`, as inline styles have higher specificity than CSS classes -->
  <v-app-bar class="main-header" :height="headerHeight" color="white" style="z-index: 15; position: sticky">
    <div class="header__container">
      <v-container class="ma-auto py-0 body-container">
        <v-layout class="align-center px-0 py-3">
          <nuxt-link
            class="index-link"
            :class="{
              textBlock: isNoLogoImage,
              funbookV2LogoBlock: isFunBookV2 && !isNoLogoImage,
              'wd-pointer-events-none': isDeferPayment,
            }"
            :to="homeUrl"
          >
            <span v-if="isNoLogoImage" class="branchName">{{ branchName }}</span>
            <img v-else-if="isFunBookV2" :src="headerLogoImage" style="height: 44px" />
            <funnow-icon v-else class="wd-w-full wd-min-w-max" style="max-height: 64px" raw :image-path="headerLogoImage" />
          </nuxt-link>

          <client-only>
            <SearchBar v-if="shouldSearchBarShow" :show-region-only="isRegionHomePage" />
          </client-only>

          <v-spacer />

          <!-- 下載 APP -->
          <client-only v-if="!isBookingEngine && !isFunBookV2">
            <v-menu key="下載 APP" :offset="24" slide-x location="bottom right">
              <template #activator="{ props }">
                <v-btn v-if="showHeaderItems" class="menu-btn mx-6 hidden-sm-and-down" color="green30" variant="outlined" v-bind="props">
                  <funnow-icon class="mr-2" max-width="24" height="24" image-path="gift--download.svg" />
                  <p class="wd-text-black50 mb-0">{{ $t('download_app_with_promo') }}</p>
                </v-btn>
              </template>

              <v-sheet class="download-menu-sheet" width="440">
                <div class="menu-header d-flex justify-space-between">
                  <p class="mb-0">{{ $t('header_download_app') }}</p>
                  <v-btn class="close-btn" :min-width="24" :width="24" :height="24" variant="text">
                    <funnow-icon class="wd-w-6 wd-h-6" image-path="cancel-icon_black.svg" />
                  </v-btn>
                </div>
                <div class="menu__content">
                  <div class="d-flex">
                    <QrCode class="mr-3" value="https://funnow.page.link/downloadapp" :size="94" foreground="#ff5537" />
                    <div>
                      <p class="content-text mb-5">{{ downloadPromoText }}</p>
                      <div class="image-row d-flex">
                        <v-img
                          class="download-btn mx-1"
                          src="@/assets/images/appdownload/atoms-web-download-googleplay.svg?url"
                          max-width="130"
                          cover
                          @click="downloadApp('android')"
                        />
                        <v-img
                          class="download-btn mx-1"
                          src="@/assets/images/appdownload/atoms-web-download-appstore.svg?url"
                          max-width="130"
                          cover
                          @click="downloadApp('ios')"
                        />
                      </div>
                    </div>
                  </div>

                  <v-img class="wd-mx-auto wd-mt-5" src="@/assets/images/funnow/funnow-gift.svg?url" :max-width="268" />
                </div>
              </v-sheet>
            </v-menu>
          </client-only>

          <!-- 切換幣別 暫時拔掉 -->
          <!-- <v-menu nudge-bottom="16" slide-x left offset-y>
            <template v-slot:activator="{ on }">
              <v-btn class="menu-btn mr-6 px-2 hidden-sm-and-down" min-width="40" height="40" text v-on="on">
                <funnow-icon :max-width="24" :image-path="'money-icon_black.svg'" />
              </v-btn>
            </template>
            <v-list :min-width="185">
              <v-list-item-group v-model="defaultCurrency" color="orange50">
                <v-list-item v-for="(currency, index) in currencyList" :key="index" :value="currency.value">
                  <v-list-item-title> {{ currency.text }} </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu> -->

          <!-- 切換語言 -->
          <client-only>
            <v-menu :offset="20" slide-x location="bottom right">
              <template #activator="{ props }">
                <v-btn
                  v-if="showHeaderItems"
                  class="menu-btn"
                  :class="{ 'mr-6 hidden-sm-and-down': !isBookingEngine }"
                  min-width="40"
                  height="40"
                  variant="text"
                  v-bind="props"
                >
                  <funnow-icon class="wd-w-6 wd-h-6" :max-width="24" :image-path="'language-icon_black.svg'" />
                </v-btn>
              </template>
              <v-list color="orange50" mandatory :min-width="185">
                <v-list-item
                  v-for="locale in languageList"
                  :key="locale.code"
                  :value="locale.code"
                  :active="locale.active"
                  @click="changeLanguage(locale)"
                >
                  <v-list-item-title> {{ locale.text }} </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </client-only>

          <!-- FunBook V2 mobile 未登入：顯示地球 icon 開 drawer 切語言 -->
          <client-only>
            <v-btn
              v-if="showHeaderItems && $vuetify.display.smAndDown && isFunBookV2 && !loggedInUser"
              class="menu-btn wd-mr-3"
              min-width="40"
              height="40"
              variant="text"
              @click="openNavigation"
            >
              <funnow-icon class="wd-w-6 wd-h-6" :max-width="24" :image-path="'language-icon_black.svg'" />
            </v-btn>
          </client-only>

          <!-- 漢堡選單 for non-FunBook non-BookingEngine guest on mobile -->
          <client-only>
            <v-btn
              v-if="showHeaderItems && $vuetify.display.smAndDown && !isBookingEngine && !isFunBookV2 && !loggedInUser"
              class="menu-btn wd-mr-3"
              min-width="40"
              width="40"
              max-height="40"
              height="40"
              variant="text"
              @click="openNavigation"
            >
              <funnow-icon :max-width="24" :image-path="'menu-icon_black.svg'" />
            </v-btn>
          </client-only>

          <!-- 登入狀態 -->
          <client-only>
            <div v-if="isAuthIconShown && showHeaderItems">
              <div v-if="!!loggedInUser" class="wd-relative">
                <v-btn id="user-menu" class="menu-btn user-menu-btn px-0" min-width="40" width="40" height="40" variant="text" @click="openUserModal">
                  <funnow-icon :max-width="24" :image-path="$vuetify.display.smAndDown ? 'menu-icon_black.svg' : 'member-icon.svg'" />
                </v-btn>
                <span
                  v-if="isProfileIncomplete"
                  class="wd-hidden md:wd-block wd-absolute wd-top-2 wd-right-2 wd-h-2 wd-w-2 wd-rounded-full wd-bg-orange50"
                />
              </div>
              <v-btn
                v-else-if="!$vuetify.display.smAndDown || isBookingEngine || isFunBookV2"
                class="menu-btn"
                variant="text"
                @click="openLoginDialog"
              >
                {{ $t(isMobile ? 'all_login' : 'header_register_login') }}
              </v-btn>
            </div>
          </client-only>
        </v-layout>
      </v-container>
    </div>
  </v-app-bar>
</template>

<script>
import { unref } from 'vue'
import { mapGetters } from 'vuex'
import { storeToRefs, mapWritableState } from 'pinia'

import tools from '@/mixin/tools'
import { useBookingEngine } from '@/composition/use-booking-engine'
import { useFunBookV2 } from '@/composition/useFunbookV2'
import { useNewUserGift } from '@/composition/useNewUserGift'
import { useBreakpoints } from '@/composition/useBreakpoints'
import { useDownloadLinks } from '@/composition/useConst'
import { useUserInfo } from '@/composition/useMember'
import { usePlatformStore } from '@/store-pinia/platform'
import { useFunBookV2Store } from '@/store-pinia/funbookV2'
import { useOrderPaymentStore } from '@/store-pinia/order-payment'
import { LoginDialogTrigger } from '@/view-models/account'

const SearchBar = defineAsyncComponent(() => import('@/components/search/search-bar.vue'))
const FunnowIcon = defineAsyncComponent(() => import('@/components/icons/funnow-icon.vue'))
const QrCode = defineAsyncComponent(() => import('qrcode.vue'))

const DEFAULT_HEADER_HEIGHT = 64

export default defineComponent({
  components: {
    SearchBar,
    FunnowIcon,
    QrCode,
  },
  mixins: [tools],
  middleware: 'auth',
  setup() {
    const route = useRoute()
    const { downloadPromoText } = useNewUserGift('header')
    const { isMobile, breakpoints } = useBreakpoints()
    const { iosLink, androidLink, unifiedLink } = useDownloadLinks()
    const platformStore = usePlatformStore()
    const { isFunBookV2 } = storeToRefs(platformStore)
    const { logoImage: logoFromFunBookV2, branchName } = storeToRefs(useFunBookV2Store())
    const { orderDetail } = storeToRefs(useOrderPaymentStore())
    const { isBookingEngine, headerLogoImage: logoFromBookingEngine, data: bookingEngineData } = useBookingEngine()
    const { branchId } = useFunBookV2()
    const { loadLocaleMessages } = useLocaleMessages()
    const localePath = useLocalePath()
    const { isProfileIncomplete } = useUserInfo()

    const isDeferPayment = computed(() => orderDetail?.value?.is_defer_payment)
    const isAuthIconShown = computed(() => !(route.query.t && route.name?.includes('orders-info') && isDeferPayment.value))

    const headerLogoImage = computed(() => (isFunBookV2.value ? logoFromFunBookV2.value : logoFromBookingEngine.value))
    const isNoLogoImage = computed(() => isFunBookV2.value && !headerLogoImage.value)

    return {
      isFunBookV2,
      isBookingEngine,
      isNoLogoImage,
      isAuthIconShown,
      isDeferPayment,
      headerLogoImage,
      branchName,
      branchId,
      bookingEngineData,
      downloadPromoText,
      isMobile,
      iosLink,
      androidLink,
      unifiedLink,
      route,
      loadLocaleMessages,
      localePath,
      breakpoints,
      isProfileIncomplete,
    }
  },
  data() {
    return {
      defaultCurrency: 0,
      language: this.$i18n.locale,
      loginLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      user: 'authentication/getUser',
      regions: 'region/allRegions',
      currencies: 'currency/allCurrency',
      hideHeaderItems: 'hideHeaderItems',
      foreignDomainFromLine: 'foreignDomainFromLine',
      foreignDomainFromMichelin: 'foreignDomainFromMichelin',
      foreignDomainFromCathay: 'foreignDomainFromCathay',
    }),
    ...mapWritableState(usePlatformStore, ['isShowLoginStep']),
    headerHeight() {
      return DEFAULT_HEADER_HEIGHT
    },
    showHeaderItems() {
      return (
        !this.hideHeaderItems &&
        !(this.foreignDomainFromLine || this.foreignDomainFromLine || this.foreignDomainFromMichelin || this.foreignDomainFromCathay)
      )
    },
    isCategoriesPage() {
      return this.route.name?.includes('regions-rid-categories-id')
    },
    isThemesPage() {
      return this.route.name?.includes('regions-rid-themes-id')
    },
    isSearchPage() {
      return this.route.name?.includes('regions-rid-search')
    },
    isTagPage() {
      return checkIfRegionTagPage(this.route.name)
    },
    isRegionHomePage() {
      return checkIfRegionHomePage(this.route.name)
    },
    shouldSearchBarShow() {
      return (
        ((this.isCategoriesPage || this.isThemesPage || this.isSearchPage || this.isTagPage) && this.breakpoints.xsAndUp) || this.isRegionHomePage
      )
    },
    categoryType() {
      if (this.isCategoriesPage) {
        return 'category'
      } else if (this.isThemesPage) {
        return 'theme'
      }
      return ''
    },
    loggedInUser() {
      return this.$auth.user
    },
    languageList() {
      const locales = unref(this.$i18n.locales)
      const locale = unref(this.$i18n.locale)
      return locales?.map(l => ({ ...l, active: l.code === locale })) || []
    },
    currencyList() {
      return this.currencies.map(currency => {
        return { value: currency.id, text: currency.code }
      })
    },
    homeUrl() {
      if (this.foreignDomainFromMichelin) {
        return this.localePath(this.$route.fullPath)
      }
      if (this.isBookingEngine) {
        return this.localePath({ path: `/branches/${this.bookingEngineData.branchId}/funbook`, query: this.$route.query })
      }
      if (this.isFunBookV2) {
        return this.localePath({
          name: 'funbook-branch_id-branch',
          params: { branch_id: this.branchId },
        })
      }
      return this.localePath({ name: 'index' })
    },
    selectedLanguageText() {
      const locales = unref(this.$i18n.locales)
      const locale = unref(this.$i18n.locale)
      const currLocale = locales.find(l => l.code === locale)
      return currLocale?.text || ''
    },
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    openUserModal() {
      this.$store.dispatch('setUserNavigation', true)
    },
    openLoginDialog() {
      this.isShowLoginStep = true
      this.$store.dispatch('dialog/setLoginDialog', { state: true, options: { from: LoginDialogTrigger.Header } })
    },
    openNavigation() {
      this.$store.dispatch('setMenuNavigation', true)
    },
    getUserInfo() {
      this.$store
        .dispatch('authentication/getUserInfo')
        .then(res => {
          this.loginLoading = false
        })
        .catch(err => {
          console.error('getUserInfo', err)
        })
    },
    downloadApp(appType) {
      let link = `${this.$config.public.BASE_URL}/app`
      if (appType === 'ios') {
        link = this.iosLink
      } else if (appType === 'android') {
        link = this.androidLink
      }
      window.open(link)
    },
    async changeLanguage({ code }) {
      await this.loadLocaleMessages(code)
      this.$vuetify.locale.current = code
      await this.$i18n.setLocale(code)
      this.$store.dispatch('region/getAllRegion')
    },
  },
})
</script>

<style scoped lang="scss" src="@/assets/sass/components/core/header.scss"></style>
<style lang="scss">
.download-menu-sheet {
  padding: 12px 20px 0;

  .menu-header {
    padding: 16px 0;
    font-size: 17px;
  }

  .menu__content {
    padding: 20px 0 0;
    color: $orange50;

    .content-text {
      white-space: pre-line;
    }

    .image-row {
      margin: 0 -4px;
    }

    .download-btn {
      cursor: pointer;
    }
  }
}
</style>
